import { styled, Theme, Typography, TypographyOwnProps } from '@mui/material';
import { Column } from 'further-ui/components/Layout';
import React, { ReactNode } from 'react';

type LineProp = {
  variant: TypographyOwnProps['variant'];
  text: string;
};

const isLineProp = (input: unknown): input is LineProp => {
  return (
    typeof input === 'object' &&
    input !== null &&
    'variant' in input &&
    'text' in input
  );
};

type Props = {
  label?:
    | { variant: TypographyOwnProps['variant']; text: string }
    | string
    | ReactNode;
  value?: string | ReactNode;
  spacing?: keyof Theme['spacingSizes'];
  centered?: boolean;
  paddingY?: keyof Theme['spacingSizes'];
  paddingX?: keyof Theme['spacingSizes'];
  muted?: boolean;
};

const StyledColumn = styled(Column, {
  shouldForwardProp: (prop) => prop !== 'paddingY' && prop !== 'paddingX',
})<{
  paddingY?: keyof Theme['spacingSizes'];
  paddingX?: keyof Theme['spacingSizes'];
}>(({ theme, paddingY, paddingX }) => ({
  paddingTop: paddingY
    ? theme.spacing(theme.spacingSizes[paddingY])
    : undefined,
  paddingBottom: paddingY
    ? theme.spacing(theme.spacingSizes[paddingY])
    : undefined,
  paddingLeft: paddingX
    ? theme.spacing(theme.spacingSizes[paddingX])
    : undefined,
  paddingRight: paddingX
    ? theme.spacing(theme.spacingSizes[paddingX])
    : undefined,
}));

const Statistic: React.FC<Props> = ({
  label,
  value,
  spacing = 'xxs',
  centered,
  muted = false,
  paddingY,
  paddingX,
}) => {
  return (
    <StyledColumn
      paddingY={paddingY}
      paddingX={paddingX}
      align="flex-start"
      centered={centered}
      spacing={spacing}
    >
      {label ? (
        <Typography variant="h6" color={muted ? 'grey.500' : 'grey.600'}>
          {isLineProp(label) ? (
            <Typography variant={label.variant}>{label.text}</Typography>
          ) : (
            label
          )}
        </Typography>
      ) : null}

      {value ? (
        <Typography variant="h2" color={muted ? 'grey.500' : 'grey.900'}>
          {isLineProp(value) ? (
            <Typography component="span" variant={value.variant}>
              {value.text}
            </Typography>
          ) : (
            value
          )}
        </Typography>
      ) : null}
    </StyledColumn>
  );
};

export default Statistic;
